import { createWebHistory, createRouter } from "vue-router";

const routes = [
    {
        path: "/",
        name: "Landing",
        component: () => import(/* webpackChunkName: "landing" */ "../pages/landing.vue"),

    },
    {
        path: "/bellingen",
        name: "Bellingen",
        component: () => import(/* webpackChunkName: "bellingen" */ "../pages/bellingen.vue"),
    },
    {
        path: "/dorrigo",
        name: "Dorrigo",
        component: () => import(/* webpackChunkName: "dorrigo" */ "../pages/dorrigo.vue"),
    },
    {
        path: "/urunga",
        name: "Urunga",
        component: () => import(/* webpackChunkName: "urunga" */ "../pages/urunga.vue"),
    },
    {
        path: "/things-to-do",
        name: "Experiences",
        component: () => import(/* webpackChunkName: "experiences" */ "../pages/things-to-do.vue"),
    },
    {
        path: "/who-we-are",
        name: "About",
        component: () => import(/* webpackChunkName: "about" */ "../pages/who-we-are.vue"),
    },
    {
        path: "/make-an-enquiry",
        name: "Enquiry",
        component: () => import(/* webpackChunkName: "enquiry" */ "../pages/enquiry.vue"),
    },
    {
        path: "/ivy-house",
        name: "Listing",
        component: () => import(/* webpackChunkName: "listing" */ "../pages/listing.vue"),
    },
    {
        path: "/:catchAll(.*)",
        name: "We cannot find what you are looking for",
        component: () => import(/* webpackChunkName: "404" */ "../pages/404.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,

    // vue-router leaves the scroll offset alone, so following a link from halfway down
    // one page opens the next one halfway down itself. Every arrival starts at the top
    // instead. It has to be instant twice over: the menu's panel only covers the jump
    // while it is still sliding away, and bootstrap's reboot puts scroll-behavior:
    // smooth on the root, which would animate the whole page up and still be running
    // as the panel reveals it
    scrollBehavior( to, from, savedPosition ) {

        // back and forward are the one case that is not a fresh arrival - return the
        // visitor to where they left that entry
        if ( savedPosition ) return { top: savedPosition.top, left: savedPosition.left, behavior: "instant" };

        return { top: 0, left: 0, behavior: "instant" };

    },
});

// each destination page is the home page of its own mini site - the main nav's home
// item returns here, so stepping back out of one belongs to the landing splash that
// chooses between destinations, not to whichever pages were visited inside it
const LANDING_PATH = "/";
const LOCATION_PATHS = [ "/bellingen", "/dorrigo", "/urunga" ];

// vue-router stamps every history entry with an incrementing position, and by the time
// a guard runs the browser has already moved to the target entry - a position behind
// the one we were on is the only signal that this navigation came from the back button
function historyPosition () {

    const state = window.history.state;

    return state && typeof state.position === "number" ? state.position : 0;

}

let currentPosition = historyPosition();

router.beforeEach( function( to, from ) {

    const isBack = historyPosition() < currentPosition;

    if ( !isBack ) return;

    if ( !LOCATION_PATHS.includes( from.path ) || to.path === LANDING_PATH ) return;

    // take over the entry that was stepped back into, so the landing page sits where
    // the visitor expects it rather than stacking on top of the destination
    return { path: LANDING_PATH, replace: true };

});

router.afterEach( function() {

    currentPosition = historyPosition();

});

export default router;
